import { OsConnection } from './osConnection.interface';
import { PrintableType } from '../print/printableType.enum';
import jsPDF from 'jspdf';

export class VirtualConnection implements OsConnection {
  window = window as any;

  customerDisplay() {}

  print(document: 'jspdf', printableType: PrintableType) {
    const pdf = new jsPDF();
    if (printableType === 8) {
      pdf.save('documento');
    } else {
      pdf.save();
    }
  }

  ventaTarjeta(
    operacionVenta: string,
    tipoComunicacionVenta: string,
    importeVenta: string,
    importeVentaDevolucion: string,
    numTerminal: string,
    versionWeb: string,
    numComercio: string,
    claveComercio: string,
    puertoCOM: string
  ) {}
}
